import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {SoundService} from "./sound.service";


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [SoundService]
})
export class SoundModule {
  static forRoot() {
    return {
      ngModule: SoundModule,
      providers: [SoundService]
    }
  }
}



// WEBPACK FOOTER //
// /Users/alex/Documents/JC/JC3 3/src/app/shared/sound/sound.module.ts